export function handleSearchQuery(spec, filters, truncate = false) {
    let query = {};

    Object.entries(filters).forEach(([key, value]) => {
        if (truncate && !spec.fields?.includes(key)) {
            return;
        }

        // Skip false, null, undefined, empty strings
        if (value === false || value === null || value === undefined || value === '') {
            return;
        }

        if (value instanceof Set) {
            // Skip empty sets
            if (value.size === 0) {
                return;
            }
            query[key] = Array.from(value).join(',');
            return;
        }

        if (spec.date?.includes(key) && value instanceof Object && !Array.isArray(value)) {
            Object.entries(value).forEach(([_key, _value]) => {
                if (_value) {
                    query[`${key}_${_key}`] = _value instanceof Date ? _value.toISOString() : _value;
                }
            });
            return;
        }

        if (spec.form?.includes(key) && value instanceof Object && !Array.isArray(value)) {
            Object.entries(value).forEach(([_key, _value]) => {
                query[`${_key}`] = _value;
            });
            return;
        }

        query[key] = value;
    });

    return query;
}

export const extractParameters = (spec, queryString) => {
    const query = queryString.startsWith('?') ? queryString.substr(1) : queryString;

    const parameters = {};

    if (!query) {
        return parameters;
    }

    for (let [key, value] of new URLSearchParams(query).entries()) {
        key = key in spec.aliases ? spec.aliases[key] : key;

        if (spec.multiple?.includes(key)) {
            parameters[key] = new Set(value.split(','));
            continue;
        }

        let isAlreadySetted = false;

        spec.date?.forEach(filterName => {
            if (key.indexOf(filterName) === 0) {
                if (!parameters.hasOwnProperty.call(parameters, filterName)) {
                    parameters[filterName] = {
                        after: null,
                        before: null
                    };
                }
                parameters[filterName][key.replace(`${filterName}_`, '')] = value;
                isAlreadySetted = true;
            }
        });

        spec.form?.forEach(filterName => {
            if (key.indexOf(filterName) === 0) {
                if (!parameters.hasOwnProperty.call(parameters, filterName)) {
                    parameters[filterName] = {};
                }
                parameters[filterName][key] = value;
                isAlreadySetted = true;
            }
        });

        if (!isAlreadySetted) {
            parameters[key] = value;
        }
    }

    return parameters;
};
